document.addEventListener('DOMContentLoaded', handlePopups);

function handlePopups() {
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has("show"))
    {
        return;
    }

    const popupId = urlParams.get('show');
    const popup = document.getElementById(popupId);
    if (!popup)
    {
        return;
    }

    popup.classList.remove('hidden');
    let timeoutId;

    // Automatisches Schließen nach 5 Sekunden
    timeoutId = setTimeout(() => {
        popup.classList.add('hidden');
    }, 5000);

    // Schließt beim Klick außerhalb
    function closeOnClickOutside(event) {
        if (!popup.contains(event.target)) {
            popup.classList.add('hidden');
            clearTimeout(timeoutId); // Timer abbrechen
            document.removeEventListener('click', closeOnClickOutside);
        }
    }

    document.addEventListener('click', closeOnClickOutside);

}
